import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./valuation-block-structure-types.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./valuation-block-structure-types.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ValuationBlockStructureTypeConfigHeadingLookup } from "./shared/enums/pv-valuation-block-structure-types.enum";
import { AppControllerService } from "../../../../../app-controller.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertType } from "../../../../../shared/models/alert";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ValuationBlockStructureTypesService } from "./shared/services/valuation-block-structure-types.service";
let ValuationBlockStructureTypesComponent = class ValuationBlockStructureTypesComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    changeDetectorRef;
    addValuationBlockStructureTypeService;
    viewApplicationService;
    appControllerService;
    modalService;
    dataSource = new BehaviorSubject([]);
    selectedStructureTypesInTable;
    tableMapper;
    addLabel = SharedConstants.ADD_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    deleteLabel = SharedConstants.DELETE_LABEL;
    valuationBlockId;
    getPropertyValuationValuationBlockStructureTypesSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, changeDetectorRef, addValuationBlockStructureTypeService, viewApplicationService, appControllerService, modalService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.changeDetectorRef = changeDetectorRef;
        this.addValuationBlockStructureTypeService = addValuationBlockStructureTypeService;
        this.viewApplicationService = viewApplicationService;
        this.appControllerService = appControllerService;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initializeColumnToObjectMapping();
    }
    ngAfterViewInit() {
        this.getValuationBlockId();
    }
    arrayReturned(array) {
        this.selectedStructureTypesInTable = array;
    }
    handleRouteChange() {
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = ValuationBlockStructureTypeConfigHeadingLookup;
    }
    getValuationBlockId() {
        const params = {
            $select: `id`, $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID} and deleted eq false`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params).pipe(map((response) => {
            return response.value;
        }))
            .subscribe({
            next: (valuationBlockIdObject) => {
                this.valuationBlockId = valuationBlockIdObject?.[0]?.id;
                if (this.valuationBlockId) {
                    this.getPropertyValuationBlockStructureTypes();
                }
                else {
                    this.appControllerService.showMessage("The ID of the current valuation block could not be found, please contact your system administrator", AlertType.Error);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage("valuation block ID", error, CRUDOperation.Get);
            }
        });
    }
    getPropertyValuationBlockStructureTypes() {
        const params = {
            $filter: `valuationBlockId eq ${this.valuationBlockId}`,
        };
        this.getPropertyValuationValuationBlockStructureTypesSubscription = this.addValuationBlockStructureTypeService.getPropertyValuationValuationBlockStructureTypes(params).subscribe({
            next: (valuationBlockStructureTypes) => {
                this.dataSource.next(valuationBlockStructureTypes);
                this.changeDetectorRef.detectChanges();
            }, error: (err) => {
                this.appControllerService.handleServerErrorMessage("valuation block structure types", err, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ChangeDetectorRef },
        { type: ValuationBlockStructureTypesService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: NgbModal }
    ];
};
ValuationBlockStructureTypesComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-valuation-block-structure-types",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ValuationBlockStructureTypesComponent);
export { ValuationBlockStructureTypesComponent };
